namespace Areas.Dialogs {
    "use strict";

    export class CreateContractorPayProfileDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateContractorPayProfile", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateContractorPayProfileForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");
                newData.ProfileStatusLk = "Active";
                newData.ProfileTypeLk = "All";

                sendRequest("/Dialog/CreateContractorPayProfile/Post", JSON.stringify(newData), "POST");
            }
        }
    }



    //not used remove if we don't add Contract lookup to dialog
    //export function contractCPLookupItem(itemData: any, itemIndex: any, itemElement: any) {
    //    itemElement.append(`<div><span class="collookupspan">${itemData.contractName}</span></div>`);
    //}
}